import React from 'react';
import { Button } from './ui/button';
import { Calendar, FileText, Users } from 'lucide-react';

export function NewsSection() {
  const newsItems = [
    {
      title: "New Digital Filing System Launch",
      description: "Experience our enhanced e-filing platform with improved security and faster processing times.",
      action: "FIND OUT HOW",
      icon: <FileText className="h-16 w-16 text-white" />,
      bgColor: "bg-gradient-to-br from-blue-600 to-blue-700",
      image: "https://images.unsplash.com/photo-1631509057887-7ef19853bc39?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb3VydGhvdXNlJTIwYnVpbGRpbmclMjBuaWdlcmlhfGVufDF8fHx8MTc1ODUwOTIyOXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
    },
    {
      title: "Free Legal Aid Program Updates",
      description: "Enhanced legal assistance for low-income families and individuals across Lagos State.",
      action: "SEE ELIGIBILITY",
      icon: <Users className="h-16 w-16 text-white" />,
      bgColor: "bg-gradient-to-br from-orange-500 to-orange-600",
      image: "https://images.unsplash.com/photo-1568092806323-8ec13dfa9b92?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxqdWRnZXMlMjBjb3VydHJvb20lMjBsZWdhbHxlbnwxfHx8fDE3NTg1MDkyMzB8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
    },
    {
      title: "Virtual Court Hearings Available",
      description: "Join court proceedings remotely with our secure video conferencing system.",
      action: "LEARN MORE",
      icon: <Calendar className="h-16 w-16 text-white" />,
      bgColor: "bg-gradient-to-br from-green-600 to-green-700",
      image: "https://images.unsplash.com/photo-1667849923693-f42338f9e130?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxnb3Zlcm5tZW50JTIwYnVpbGRpbmclMjBqdXN0aWNlfGVufDF8fHx8MTc1ODUwOTIzNHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
    }
  ];

  return (
    <section className="py-8 lg:py-12 bg-blue-900 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        <h2 className="text-3xl lg:text-4xl text-white mb-8 text-center">
          See what's new from Lagos State Judiciary
        </h2>

        <div className="grid lg:grid-cols-3 gap-8">
          {newsItems.map((item, index) => (
            <div key={index} className="group cursor-pointer">
              <div className={`${item.bgColor} rounded-lg overflow-hidden h-96 relative`}>
                {/* Background Image */}
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-20"
                />
                
                {/* Content */}
                <div className="relative p-8 h-full flex flex-col justify-between">
                  <div>
                    <div className="mb-6">
                      {item.icon}
                    </div>
                    <h3 className="text-2xl text-white mb-4">
                      {item.title}
                    </h3>
                    <p className="text-blue-100 mb-6 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                  
                  <Button 
                    variant="outline" 
                    className="hover:bg-white hover:text-blue-900 transition-colors w-fit"
                  >
                    {item.action}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}